export default {
    computed: {
        userTrophyIds() {
            if (!this.user || !Array.isArray(this.user.trophies)) {
                return []
            }

            return this.user.trophies
                .map(trophy => trophy.id)
                .filter(id => id !== null && id !== undefined)
                .map(id => Number(id))
        },
    },

    methods: {
        requiredTrophiesFor(campaign) {
            const source = campaign && Array.isArray(campaign.interests) ? campaign.interests : []

            return source
                .map((item, index) => this.normalizeRequiredTrophy(item, index))
                .filter(trophy => trophy !== null)
                .sort((a, b) => Number(a.isEarned) - Number(b.isEarned))
        },

        hasRequiredTrophiesFor(campaign) {
            return this.requiredTrophiesFor(campaign).length > 0
        },

        hasAllRequiredTrophiesFor(campaign) {
            if (!this.hasRequiredTrophiesFor(campaign)) {
                return true
            }

            return this.requiredTrophiesFor(campaign).every(trophy => trophy.isEarned)
        },

        normalizeRequiredTrophy(item, index) {
            const trophy = item && item.trophy ? item.trophy : item

            if (!trophy || typeof trophy !== 'object') {
                return null
            }

            const trophyId = trophy.id || item.id || null
            const trophyName = trophy.name || `Trofae ${index + 1}`
            const trophyIcon = (trophyId ? `/img/trophies/icons/trophy_icon_${trophyId}.svg` : null)
            const courseUrl = (trophyId ? `/school/course/${trophyId}` : this.schoolUrl)

            const hasOwnedMarker = Boolean(
                trophy.is_owned || trophy.owned || item.is_owned || item.owned
            )
            const isEarned =
                hasOwnedMarker ||
                (trophyId !== null && this.userTrophyIds.includes(Number(trophyId)))

            return {
                key: trophyId || index,
                name: trophyName,
                icon: trophyIcon,
                courseUrl: courseUrl,
                isEarned,
            }
        },
    },
}
